import { render } from "./SavedBatch.vue?vue&type=template&id=9923c85e&scoped=true"
import script from "./SavedBatch.vue?vue&type=script&lang=js"
export * from "./SavedBatch.vue?vue&type=script&lang=js"

import "./SavedBatch.vue?vue&type=style&index=0&id=9923c85e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9923c85e"]])

export default __exports__